// Import model
import { UpdatePointRequest } from '../models/UpdatePointRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for UpdatePointRequest - handles JSON serialization and deserialization with type validation
 */
export class UpdatePointRequestSerializer {
  /**
   * Deserializes a JSON string into a UpdatePointRequest instance
   */
  static deserialize(json: string): UpdatePointRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a UpdatePointRequest instance
   */
  static fromObject(obj: any): UpdatePointRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to UpdatePointRequest');
    }


    const instance: UpdatePointRequest = {
      x: obj['x'] as number | undefined,
      y: obj['y'] as number | undefined,
      z: obj['z'] as number | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of UpdatePointRequest instances
   */
  static deserializeArray(json: string): UpdatePointRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a UpdatePointRequest instance to a JSON string
   */
  static serialize(instance: UpdatePointRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a UpdatePointRequest instance to a plain object
   */
  static toObject(instance: UpdatePointRequest): any {
    return {
      'x': instance.x,
      'y': instance.y,
      'z': instance.z,
    };
  }

  /**
   * Serializes an array of UpdatePointRequest instances to a JSON string
   */
  static serializeArray(instances: UpdatePointRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
